import './Button.scss';

const PrimaryButton = ({ label, className = "", ...props }) => (
    <button type="button" className={`custom-primary-btn ${className}`} {...props}>
        <div className="primary-btn-label">{label}</div>
    </button>
);

const SecondaryButton = ({ label, className = "", ...props }) => (
    <button type="button" className={`custom-secondary-btn ${className}`} {...props}>
        <div className="secondary-btn-label">{label}</div>
    </button>
);

const BrandedLinkButton = ({ label, isLarge, className = "", ...props }) => (
    <button type="button" className={`branded-link-btn ${className}`} {...props}>
        <div className={`branded-link-label ${isLarge ? 'large' : ''}`}>{label}</div>
    </button>
);

export { PrimaryButton, SecondaryButton, BrandedLinkButton };
